export default "__VITE_ASSET__794a8f39__"